import 'consumerweb-shim';
import React from 'react';
import { connect } from 'react-redux';
import { Text } from 'pp-react';
import { get } from 'lodash';
import Carousal from '../../carousel';

import * as ViewActions from '../actions/Actions';
import * as analytics from '../../../lib/analytics';
import styles from './carouselContainer.less';

export class Carousel extends React.Component {
  renderPlay = index => {
    this.props.dispatch(ViewActions.startVideo(index));

    analytics.trackLinkWithData(
      'videoPlayButton',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { videoIndex: index },
      'link'
    );
  };

  closeVideoPlay = index => {
    this.props.dispatch(ViewActions.stopVideo(index));
  };

  // renderSlide() {
  //   this.props.dispatch(ViewActions.slideCarousel());
  // },

  handleAnalytics = click => {
    analytics.trackLink(
      click,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  };

  render() {
    let carouselContent = this.props.templateData.lpContents;
    let campaignInfo = this.props.data;
    let cmpnHeader = carouselContent.cmpnHeader ? carouselContent.cmpnHeader : campaignInfo.campaignTitle;
    let cmpnSubHeader = carouselContent.cmpnSubHeader ? carouselContent.cmpnSubHeader : campaignInfo.campaignDesc;
    const matchingStatus = get(this.props, 'data.matchingStatus', '');
    let postCapSubHeader = get(this.props, 'data.templateData.incentiveCap.postCapDescription', '');
    let isIncentiveCap = get(this.props, 'data.templateData.incentiveCap.isIncentiveCap', '');
    if (isIncentiveCap === 'yes' && matchingStatus) {
      cmpnSubHeader = matchingStatus === 'MATCHING' ? cmpnSubHeader : postCapSubHeader;
    }

    return (
      <div className={'carouselMainContainer'}>
        <Carousal
          renderPlay={this.renderPlay}
          carouselContent={carouselContent}
          closeVideoPlay={this.closeVideoPlay}
          {...this.props}
        />
        <div className={'heroContentContainer'}>
          <Text className={styles.heroTitle} as='h1' size='xl4' regular>
            {cmpnHeader}
          </Text>
          <Text
            as='p'
            size='xl'
            regular
            onClick={this.handleAnalytics.bind(this, 'seeTerms')}
            className={styles.herosubTitle}
            dangerouslySetInnerHTML={{ __html: cmpnSubHeader }}
          />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  // connects reducer with component
  playVideo: state.carousel.playVideo,
  videoIndex: state.carousel.videoIndex,
  stopVideo: state.carousel.stopVideo,
  templateData: state.server.templateData,
  data: state.server.data,
}))(Carousel);
